import { useTranslation } from 'react-i18next';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { TTCM_STATUS_CUSTOM_OPTIONS } from '@anytag/shared-constants';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const TTCMStatusField = (
  props: Omit<SingleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const ttcmStatusOptions = useTranslateOptions(TTCM_STATUS_CUSTOM_OPTIONS);

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="ttcmStatus"
      clearable={false}
      title={t('Selector.TTCM Status')}
      options={ttcmStatusOptions}
      {...props}
    />
  );
};
